// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","exportBtns":"export-buttons_exportBtns__YB83k","excel":"export-buttons_excel__WguXr","print":"export-buttons_print__Wn1QX"};